<div class="container">
  <h1>Update Devices Tags</h1>
  @if (!showLists) {
  @if (files == null || files.length === 0) {
  <div class="uploadfilecontainer" (click)="fileInput.click()" appDragNDrop
    (onFileDropped)="handleDroppedFiles($event);">
    <input hidden type="file" id="fileInput" #fileInput (change)="onFileInput($event.target['files'])" multiple>
    Drag or Click to Upload
  </div>

  <p class="uploadHelp">What file types are allowed?
    <mat-icon class="pointer" matTooltip="Only CSV files are allowed">
      contact_support
    </mat-icon>
  </p>
  } @else {
  <div>
    <p>Selected File:</p>
    <div class="files-list">
      <p style="width: 100%;"> {{ files[0].name }} @if (!working) {
        <span class="material-icons delete-icon" (click)="deleteFile()">delete_forever</span>
        }
      </p>
    </div>

  </div>
  }
  @if (!loading){
  <div class="centered-button">
    <button (click)="downloadTemplate()" mat-raised-button>Download Template</button>
  </div>
  }
  <div class="buttons">
    @if (!loading) {
    <button (click)="update()" mat-raised-button>Update Device Tags</button>
    } @else {
    <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
    }
    <button (click)="close()" mat-raised-button>Cancel</button>
  </div>
  } @else {
  <div style="max-width: 600px; margin: auto;">
    <mat-accordion multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>✅ Successfully Updated Devices</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
          <mat-list-item *ngFor="let device of devicesUpdated">
            <div style="white-space: normal; word-break: break-word;">
              DeviceNum: <strong>{{ device.DeviceNum }}</strong>, TagName: <strong>{{ device.TagName }}</strong>
            </div>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>⚠️ Failed Devices</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
          <mat-list-item *ngFor="let device of devicesFailed">
            <div style="white-space: normal; word-break: break-word;">
              DeviceNum: <strong>{{ device.DeviceNum }}</strong>, TagName: <strong>{{ device.TagName }}</strong>
            </div>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>

    <div style="text-align: center; margin-top: 16px;">
      <button (click)="close()" mat-raised-button>Close</button>
    </div>
  </div>
  }

</div>